import { gql } from '@apollo/client'

export const Query = gql`
  query AssetType($companyId: ID!, $filters: AssetTypeFilters) {
    assetTypes(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        costCents
        rateCents
        availableToEvents
        displayOnWebsite
        description
        weight
        revenueCents
        returnOnInvestment
        stockCount
        assets {
          count
        }
        categories {
          id
          name
          color
        }
        images {
          id
          url
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
